import type { FC } from 'react'
import styled from 'styled-components'

import List from './List'

const SectionSummary = styled.div`
  background: #f2f1f1;
  border-radius: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 40px;
  padding: 20px;
  justify-content: center;
`

interface Props {
  pros: string[]
  cons: string[]
}

const ProsCons: FC<Props> = ({ pros, cons }) => (
  <SectionSummary>
    <List header={<>👍</>} listItemIconPath="/assets/svg/success.svg" items={pros} />
    <List header={<>👎</>} listItemIconPath="/assets/svg/fail.svg" items={cons} />
  </SectionSummary>
)

export default ProsCons
